import { GetterTree } from 'vuex';
import { SearchState } from '../../models';
import { RootStoreState } from '../store.interfaces';
import { GridItemsGetter } from './getters/grid-item.getter';
import { HasMoreResultsGetter } from './getters/has-more-results.getter';
import { HasResultsGetter } from './getters/has-results.getter';
import { InfiniteScrollEnabledGetter } from './getters/infinite-scroll-enabled.getter';
import { RemainingFacetsGetter } from './getters/remaining-facets.getter';
import { ResultsCallbackInfoGetter } from './getters/results-callback-info.getter';
import { SearchBoxSuggestionGetter } from './getters/search-box-suggestion.getter';
import { SearchRequestGetter } from './getters/search-request.getter';
import { SelectedFiltersGetter } from './getters/selected-filters.getter';
import { ShowSearchComponentsGetter } from './getters/show-search-components.getter';

export const SEARCH_GETTERS: GetterTree<SearchState, RootStoreState> = {
  ...new GridItemsGetter().getters,
  ...new HasMoreResultsGetter().getters,
  ...new HasResultsGetter().getters,
  ...new InfiniteScrollEnabledGetter().getters,
  ...new RemainingFacetsGetter().getters,
  ...new ResultsCallbackInfoGetter().getters,
  ...new SearchBoxSuggestionGetter().getters,
  ...new SearchRequestGetter().getters,
  ...new SelectedFiltersGetter().getters,
  ...new ShowSearchComponentsGetter().getters
};
